
export const generateBlobLink = (data, type) => {
  var blob = new Blob([data], { type: type });
  const relsUrl = URL.createObjectURL(blob);
  return relsUrl;
};
